// Web v3 copy, canonical comp updated October 2, 2026.
// Outcome claims remain gated by existing authoritative state.
// Spanish: the Founder's full review of 2026-10-06, applied by scripts/apply-spanish-review.js.

export const en = {
  "home.redirecting": "Taking you to {site}…",

  "footer.publisher": "Published by {publisher}",
  "footer.privacy": "Privacy",
  "footer.terms": "Terms",
  "footer.help": "Support",

  "error.stale.title": "Refresh this page",
  "error.stale.body":
    "",
  "error.stale.reload": "Refresh page",
  "error.stale.fallback":
    "Still seeing this after reloading? Close this tab and open the link again.",

  "error.notFound.title": "This page isn’t here",
  "error.notFound.body": "",
  "error.notFound.hint":
    "",

  "common.loading": "Loading…",
  "common.openLura": "Open Lura",
  "common.tryAgain": "Try again",
  "common.signIn": "Sign in",
  "common.signInToContinue": "Sign in to continue.",
  "common.signInHere": "sign in here",
  "common.continue": "Continue",
  "common.checkingSession": "Checking your session…",
  "common.returnToApp": "",
  "common.backFromStripe": "",
} as const;

export type CoreKey = keyof typeof en;

export const es: Partial<Record<CoreKey, string>> = {
  // These paragraphs are intentionally omitted in both locales; no translated prose.
  "error.stale.body": "",
  "error.notFound.body": "",
  "error.notFound.hint": "",
  "common.returnToApp": "",
  "common.backFromStripe": "",
  "home.redirecting": "Te llevamos a {site}…",
  "footer.publisher": "Publicado por {publisher}",
  "footer.privacy": "Privacidad",
  "footer.terms": "Términos",
  "footer.help": "Soporte",
  "error.stale.fallback":
    "¿Sigue pasando después de volver a cargar? Cierra esta pestaña y abre el enlace de nuevo.",
  // Founder-approved with the page titles, 2026-10-06 (copy-1).
  "error.stale.title": "Vuelve a cargar esta página",
  "error.notFound.title": "Esta página no está disponible",
  "common.loading": "Cargando…",
  "common.openLura": "Abrir Lura",
  "common.tryAgain": "Intentar de nuevo",
  "common.signIn": "Iniciar sesión",
  "common.signInToContinue": "Inicia sesión para continuar.",
  "common.signInHere": "iniciar sesión aquí",
  "common.continue": "Continuar",
  "common.checkingSession": "Verificando tu sesión…",
  "error.stale.reload": "Volver a cargar la página",
};
